import { Component, inject, Input, TemplateRef } from '@angular/core';
import { NgClass } from '@angular/common';

import { NgbActiveModal, NgbCollapse } from '@ng-bootstrap/ng-bootstrap';

import { NotificationModalOptions } from '../../models/notification-modal-options';


@Component({
    selector: 'app-notification-modal',
    imports: [NgbCollapse, NgClass],
    templateUrl: './notification-modal.component.html',
    styleUrls: ['./notification-modal.component.scss']
})
export class NotificationModalComponent {
  @Input() options!: NotificationModalOptions;

  private readonly activeModal = inject(NgbActiveModal);

  errorCollapsed: boolean = true;

  abort(): void {
    this.activeModal.close(false);
  }

  confirm(): void {
    this.activeModal.close(true);
  }

  isTemplate() { return this.options.message instanceof TemplateRef; }

}
